if (!customElements.get('product-set-part-out')) {
  customElements.define(
    'product-set-part-out',
    class ProductSetPartOut extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a');
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.sectionId) return;
          this.update(event.data.variant?.sku);
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      update(sku) {
        const normalizedSku = typeof sku === 'string' ? sku.trim() : '';
        this.hidden = normalizedSku.length === 0;

        if (!this.link || this.hidden) return;
        this.link.href = this.dataset.urlTemplate.replaceAll('{SKU}', encodeURIComponent(normalizedSku));
      }
    }
  );
}
